import { DotsHorizontalIcon } from "@radix-ui/react-icons";
import { Edit3, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useI18n } from "@/locales/client";

interface QuestionActionDropDownProps {
  disabled?: boolean;
  setIsEditOpen: (open: boolean) => void;
  setIsDeleteOpen: (open: boolean) => void;
}

const QuestionActionDropDown = ({
  disabled,
  setIsEditOpen,
  setIsDeleteOpen,
}: QuestionActionDropDownProps) => {
  const t = useI18n();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          disabled={disabled}
          onClick={(e) => e.stopPropagation()}
          className="h-8 w-8 text-muted-foreground hover:text-foreground"
        >
          <DotsHorizontalIcon className="size-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-40">
        <DropdownMenuItem
          onClick={(e) => {
            e.stopPropagation();
            setIsEditOpen(true);
          }}
          className="gap-2"
        >
          <Edit3 size={16} />
          {t("questionActions.actions.edit")}
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem
          onClick={(e) => {
            e.stopPropagation();
            setIsDeleteOpen(true);
          }}
          className="gap-2 text-destructive focus:text-destructive"
        >
          <Trash2 size={16} />
          {t("questionActions.actions.delete")}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default QuestionActionDropDown;
